import { Grid, Typography } from '@material-ui/core';
import React, { useEffect, useContext } from 'react';
import { Container } from '../../../../Components';
import { FormattedMessage, useIntl } from 'react-intl';
import { ModuleContext } from '../../../../Context/ModuleContext/ModuleContext';
import { useStyles } from './Dashboard.styles';
import { NewLawChangesWidget } from './Widget.NewLawChanges';
import { NewLawsWidget } from './Widget.NewLaws';
import { NewUsersWidget } from './NewUsers';
import { TaggedItemsWidget } from './Tagged';
import { AccessLevel, OrganizationFeature, useUser } from '../../../../Context/UserContext/UserContext';
import { InformationBoardWidget } from './InformationBoardWidget';
import { ChangeUnacknowledgedLaw } from './Widget.ChangeUnacknowledgedLaw';
import { ImpersonationRequestsWidget } from './ImpersonationRequestsWidget';
import { getAppConfiguration } from '../../../../Config';

export const Dashboard = () => {
  const classes = useStyles();

  const { setHeader } = useContext(ModuleContext);
  const { formatMessage } = useIntl();
  const { hasAccessToFeature, applicationVersion } = useUser();
  const { enableImpersonation } = getAppConfiguration();
  // const showImpersonationRequests = enableImpersonation && applicationVersion?.value !== 1;
  const showNewUsersWidget =
    hasAccessToFeature(OrganizationFeature.Manage, AccessLevel.Administer) &&
    hasAccessToFeature(OrganizationFeature.AAD, AccessLevel.Manage);

  useEffect(() => {
    setHeader(formatMessage({ id: 'law-portal.dashboard.header', defaultMessage: 'Dashboard' }));
  }, [setHeader, formatMessage]);

  return (
    <Container fullWidth>
      <Grid container justifyContent="space-evenly" spacing={2}>
        {/* <Grid item sm={5}>
          <Typography variant="h1" component="h2" gutterBottom>
            <FormattedMessage id="law-portal.dashboard.welcome"></FormattedMessage>
          </Typography>
          <Typography>
            <FormattedMessage
              id="law-portal.dashboard.information"
              values={{
                i: (parts: React.ReactNode[]) => (
                  <span className={classes.italics}>{parts}</span>
                ),
                b: (parts: React.ReactNode[]) => (
                  <span className={classes.bold}>{parts}</span>
                ),
                mailTo: (parts: React.ReactNode[]) => (
                  <a href={`mailto:${parts}`}>{parts}</a>
                ),
                tel: (parts: React.ReactNode[]) => (
                  <a href={`tel:${parts}`}>{parts}</a>
                ),
                oldLink: (parts: React.ReactNode[]) => (
                  <a href="https://old.lagportalen.se">{parts}</a>
                ),
                brDbl: () => (
                  <>
                    <br />
                    <br />
                  </>
                ),
                br: () => <br />,
              }}
            />
          </Typography>

        </Grid> */}
        <Grid item xs={12} sm={7} className={classes.dashboardColumn}>
          <Grid container spacing={2} direction="column">
            {enableImpersonation && <ImpersonationRequestsWidget />}
            <Grid item>
              {/* <NewLawChangesWidget /> */}
              <ChangeUnacknowledgedLaw/>
            </Grid>
            <Grid item>
              <TaggedItemsWidget />
            </Grid>
            <Grid item>
              <NewLawsWidget />
            </Grid>
            {showNewUsersWidget && (
              <Grid item>
                <NewUsersWidget />
              </Grid>
            )}
          </Grid>
        </Grid>
         <Grid item xs={12} sm={5} className={classes.dashboardColumn}>
          <InformationBoardWidget />

        </Grid>
      </Grid>
    </Container>
  );
};
